import { Box, Button, Card } from '@mui/material';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { Business_Profile_Enum } from '@kheops/graphql';
import useAuth from '../hooks/useAuth/useAuth';
import { BuyerNavigation, MobileNavigation, SupplierNavigation } from '../common/state/navigation';
import { currentContextAtom } from '../state';
import { RoutePaths } from '../routes/AppRoutes';
import TopAppBar from '../common/components/TopAppBar';
import NavigationSection from './NavigationSection';

export default function NavigationMain(): React.JSX.Element {
  const { t } = useTranslation(['common']);
  const context = useAtomValue(currentContextAtom);
  const { logout } = useAuth();
  const navigationItems = context.realm === Business_Profile_Enum.Supplier ? SupplierNavigation : BuyerNavigation;

  return (
    <>
      <TopAppBar
        configuration="small"
        backTo={RoutePaths.ROOT}
        shouldCheckHistory={false}
        title={t('common:your_company')}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mx: 2, my: 0.5 }}>
        <Card sx={{ py: 1, px: 1, borderRadius: 3 }}>
          <NavigationSection items={navigationItems} />
        </Card>
        <Card sx={{ py: 1, px: 1, borderRadius: 3 }}>
          <NavigationSection items={MobileNavigation} />
        </Card>
      </Box>
      <Box
        sx={{
          position: 'fixed',
          backgroundColor: 'surface.main',
          bottom: 0,
          width: 'calc(100% - 32px)',
          p: 2,
        }}
      >
        <Button
          startIcon={<LogoutOutlinedIcon />}
          onClick={logout}
          variant="outlined"
          fullWidth
        >
          {t('common:sign_out')}
        </Button>
      </Box>
    </>
  );
}
